import { render, staticRenderFns } from "./rights.vue?vue&type=template&id=168ff14d&scoped=true&"
import script from "./rights.vue?vue&type=script&lang=js&"
export * from "./rights.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "168ff14d",
  null
  
)

export default component.exports